/* eslint-disable react/jsx-no-comment-textnodes */
import React, { Component } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import 'react-croppie/cropper.css';


import  Croppie from "croppie";

import image from "./a2.png";
import mergeImages from 'merge-images';

const croppieOptions = {
  showZoomer: true,
  enableOrientation: true,
  mouseWheelZoom: "ctrl",
  viewport: {
    width: 430 ,
    height: 430,
    type: "circle"
  },
  boundary: {
    width: 430,
    height: 430
  }
};

const croppie = document.getElementById("croppie");
const c = new Croppie(croppie, croppieOptions);


 class App extends Component {
   state = {
     croppedImage: null,
     isFileUploaded: false,
     sticker: null,
     done: false,
     dataUrl: null,
     name: ""
   };
   componentDidMount() {
     const canvas = this.refs.canvas;
     const ctx = canvas.getContext("2d");
     const img = this.refs.image;
    //  var heightRatio = 1.5;
     let dataURL = null;
      img.onload = (el) => {
        ctx.drawImage(img, 0, 0);
        ctx.font = "60px Courier";
        ctx.fillText(this.state.name, 400, 940);
        // this.setState({final_img: this.state.sticker})
        dataURL = canvas.toDataURL();
        this.setState({dataUrl: dataURL})
        console.log(dataURL)
        canvas.height = 1080;
        canvas.width = 1080;
      };
   }
   

   file = React.createRef();
   croppie = React.createRef();
   img = React.createRef();

   onFileUpload = (e) => {
     this.setState({ isFileUploaded: true }, () => {
       const reader = new FileReader();
       const file = this.file.current.files[0];
       reader.readAsDataURL(file);
       reader.onload = () => {
         c.bind({ url: reader.result });
       };
       reader.onerror = function (error) {
         console.log("Error: ", error);
       };
     });
   };
   handleChange = e => {
     const {name, value} = e.target;
     this.setState({[name]: value})
   }

   onResult = (e) => {
     c.result("base64").then((base64) => {
       this.setState({ croppedImage: base64, done: true });
     });
   };

   mergeImg = async () => {
     await this.onResult();
     console.log(image, this.state.croppedImage);

     const merge = await mergeImages([
       { src: image, x: 0, y: 0 },
       { src: this.state.croppedImage, x: 330, y: 450 },
     ]);
     this.setState({ sticker: merge, done: true});
   };
   render() {
     const { isFileUploaded } = this.state;

     return (
       <div className="App m-4 p-2">
         <h2> Step 1 </h2>
         <p> Choose an image and drag to fit </p>
         <input
           type="file"
           id="files"
           ref={this.file}
           onChange={this.onFileUpload}
         />
         <input
           type="text"
           onChange={this.handleChange}
           name="name"
           placeholder="Please enter a name"
           style={{ borderRadius: "20px", paddingLeft: "10px", marginTop: "1rem" }}
         />
         <hr />

         <h2> Step 2</h2>
         <button
           className="btn btn-default btn-success mt-3 mb-2 "
           type="button"
           disabled={!isFileUploaded}
           onClick={this.mergeImg}
         >
           Upload
         </button>
         <hr />
         <h2> Result! </h2>
         <div>
           {this.state.done ? (
             <React.Fragment>
               <img src={this.state.dataUrl} alt="sticker" width="200" />
               <p>
                 {" "}
                 {/* <a
                   download
                   href={this.state.dataUrl}
                   // onClick={this.state.sticker}
                   className="btn btn-default btn-danger mt-3"
                 >
                   Download
                 </a> */}
               </p>
             </React.Fragment>
           ) : (
             <React.Fragment>
               <img src={image} alt="img" width="200" />
             </React.Fragment>
           )}
           <div className="canvas">
             <canvas
               ref="canvas"
               id="canvas"
               width={1080}
               height={1080}
               style={{ display: "none" }}
             />
             <img
               ref="image"
               src={this.state.sticker}
               className="hidden"
               style={{ display: "none" }}
               alt="Final"
             />
             <a
               href={this.state.dataUrl}
               download
               className="btn btn-default btn-danger mt-3"
             >
               Download
             </a>
           </div>
         </div>
       </div>
     );
   }
 }




export default App;
